import type { AmbleContent } from "..";

/**
 * Site-specific ambles organized by site name
 */
export const siteAmbles: Record<string, Record<string, AmbleContent>> = {
  // Example structure:
  // comparethemarket: {
  //   "example-amble": "<p>CompareTheMarket specific content</p>",
  // },
  // moneysupermarket: {
  //   "example-amble": "<p>MoneySuperMarket specific content</p>",
  // },
};
